/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

export enum ApplicationDataKey {
  /**
   * Application name
   */
  APP_NAME = 'app_name',
  /**
   * Application version
   */
  APP_VERSION = 'app_version',
  /**
   * Application build version
   */
  APP_BUILD_VERSION = 'app_build',
  /**
   * Application product
   */
  APP_PRODUCT = 'product',
  /**
   * Application version ID
   */
  APP_VERSION_ID = 'app_version_id',

  /** Selected display language of the user interface */
  DISPLAY_LANGUAGE = 'display_language',

  /** Property identifier for the current application context */
  PROPERTY = 'property',

  /** Station identifier for the current application context */
  STATION = 'station',

  QP_SDK_VERSION = 'qp_sdk_version',
}
